// /web/src/components/SiteHeader.jsx
import React from "react";
import { Link, NavLink } from "react-router-dom";

import Logo from "./Logo.jsx";

export default function SiteHeader({
  navLinks = [],
  isAuthenticated,
  isLoading,
  onLogin,
  onLogout,
  onSignup,
  plan,
  showPlanSummary = false,
}) {
  return (
    <header className="pd-header">
      <div className="pd-container pd-header__inner">
        <Link to="/" className="pd-logo" aria-label="Pebbledash — Home">
          <Logo alt="Pebbledash" />
        </Link>

        <nav className="pd-nav--center" aria-label="Primary">
          {navLinks.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? "pd-active" : undefined)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <nav
          className={`pd-nav--auth${isAuthenticated ? " pd-nav--auth--authed" : ""}`}
          aria-label="Account"
        >
          {isAuthenticated ? (
            <>
              {showPlanSummary ? (
                <span className="pd-plan-summary" aria-live="polite">
                  Plan: <strong>{plan ?? "—"}</strong>
                </span>
              ) : null}
              <Link className="pd-btn pd-btn--ghost pd-btn--compact" to="/dashboard">
                Dashboard
              </Link>
              <button
                type="button"
                className="pd-btn pd-btn--primary pd-btn--compact"
                onClick={onLogout}
                disabled={isLoading}
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="pd-btn pd-btn--ghost"
                onClick={onLogin}
                disabled={isLoading}
              >
                Log in
              </button>
              <button
                type="button"
                className="pd-btn pd-btn--primary"
                onClick={onSignup}
                disabled={isLoading}
              >
                Sign up
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
